module.exports = __webpack_public_path__ + "static/sport/bg.e3728fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/bg.jpg
// module id = t27e
// module chunks = 0